<template>
  <div
    :class="[
      'space-y-3 mb-4 p-4 border-b border-blue-300/30 max-w-screen-md bg-[var(--fundoForm)] rounded-md',
      { hidden: !show },
    ]"
  >
    <div
      class="flex justify-between cursor-pointer border border-blue-300/30 p-2 rounded-md"
    >
      <h2 class="text-[var(--text)] text-lg font-semibold">{{ form_title }}</h2>
      <div class="cursor-pointer" @click="$emit('cancel')">
        <i class="fa-solid fa-close xl text-[var(--text)]"></i>
      </div>
    </div>

    <ValidatedSelect
      name="familia_id"
      label="Família:"
      v-model="formModel.familia_id"
      :options="familias"
      placeholder="Selecionar família..."
      :required="true"
      :show-errors="true"
      :rules="familiaRule"
    />

    <ValidatedTextarea
      name="descricao"
      label="Descrição:"
      v-model="formModel.descricao"
      placeholder="Descrição da entrada"
      :rows="3"
      :rules="descricaoRule"
    />

    <div class="space-y-1">
      <div class="flex justify-between items-center px-1">
        <span class="text-[var(--text)] text-sm text-right font-medium w-1/6"
          >Template PDF:</span
        >
        <button
          @click="openEditorModal"
          type="button"
          class="text-blue-400 hover:text-blue-300 text-xs flex items-center gap-1 transition-colors"
        >
          <i class="fa-solid fa-expand"></i>
          Expandir Editor
        </button>
      </div>

      <div class="rounded-md border border-blue-300/20 overflow-hidden">
        <FlowbiteEditor
          v-model="formModel.template_text"
          :enable-table="true"
          height="200px"
        />
      </div>

      <div
        v-if="isEditorModalOpen"
        class="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      >
        <div
          class="bg-[var(--fundoApp)] w-full max-w-5xl h-[90vh] rounded-lg shadow-2xl flex flex-col border border-white/10"
        >
          <div
            class="flex justify-between items-center p-4 border-b border-white/10 bg-white/5"
          >
            <h2 class="text-lg font-bold text-[var(--text)] flex items-center gap-2">
              <i class="fa-solid fa-pen-to-square text-blue-500"></i>
              Editar Template
            </h2>
            <button
              @click="closeEditorModal"
              class="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white px-3 py-1 rounded transition-all"
            >
              Fechar e Voltar
            </button>
          </div>

          <div class="p-6 flex-1 overflow-y-auto bg-[var(--fundoForm)]">
            <FlowbiteEditor
              v-model="formModel.template_text"
              placeholder="Observações que aparecerão no PDF do orçamento..."
              height="420px"
              :enable-table="true"
            />
          </div>

          <div class="p-4 border-t border-white/10 bg-white/5 flex justify-end">
            <button
              @click="closeEditorModal"
              class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded shadow-lg"
            >
              Confirmar Edição
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-6">
      <button
        class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors"
        @click="onSave"
        :disabled="loading"
      >
        Salvar
      </button>
      <button
        class="bg-gray-400 hover:bg-gray-500 text-[var(--text)] px-4 py-2 rounded transition-colors"
        @click="onCancel"
        :disabled="loading"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
import ValidatedSelect from "@/components/ValidatedSelect.vue";
import ValidatedTextarea from "@/components/ValidatedTextarea.vue";
import FlowbiteEditor from "@/components/shared/FlowbiteEditor.vue";
import { commonRules } from "@/validations/rules/common.js";
import * as yup from "yup";

export default {
  name: "TemplateForm",
  components: {
    ValidatedSelect,
    ValidatedTextarea,
    FlowbiteEditor,
  },
  props: {
    show: Boolean,
    familias: Array,
    fornecedores: Array,
    initialEditModel: {
      type: Object,
      default: () => ({
        familia_id: null,
        descricao: "",
      }),
    },
    form_title: String,
  },
  data() {
    return {
      formModel: { ...this.initialEditModel },
      familiaRule: commonRules.required("Família"),
      descricaoRule: yup.string().nullable(),
      loading: false,
      selectedFile: null,
      uploadMessage: "",
      uploadMessageClass: "",
      showImageModal: false,
      imageUrl: null,
      isEditorModalOpen: false,
    };
  },
  methods: {
    async onSave() {
      this.loading = true;
      const payload = {
        ...this.formModel,
        familia_id: this.formModel.familia_id?.id || this.formModel.familia_id,
      };

      this.$emit("save", payload);
      this.loading = false;
    },
    onCancel() {
      this.$emit("cancel");
    },
    openEditorModal() {
      this.isEditorModalOpen = true;
    },
    closeEditorModal() {
      this.isEditorModalOpen = false;
    },
  },
  watch: {
    initialEditModel: {
      handler(newVal) {
        const familia = this.familias.find((f) => f.id === newVal.familia_id);
        this.formModel = {
          ...newVal,
          familia_id: familia || newVal.familia_id, // Set to object if found, otherwise keep the id
        };
      },
      deep: true,
      immediate: true,
    },
    formModel: {
      handler(newVal) {
        this.$emit("edit-model-changed", newVal);
      },
      deep: true,
    },
  },
  emits: ["edit-model-changed", "open-contact-crud", "save", "cancel"],
};
</script>
